import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import { Verification } from '../../../components/dialogs/Verification';
import image from '../../../assets/Homepage-Image.jpg';
import { useAuth } from '../../../context/auth';
import {
    StyledContainer,
    SectionName, 
    SectionTitle,
} from '../../Home.styles';
import {
    StepsContainer,
    Step, 
    StepTitle, 
    StepDescription, 
    StepNumber,
    DotContainer,
    Dot,
    Image,
    ImageWrapper,
    StyledButton,
    Button
} from './Steps.styles';

export function Steps() {
    const [verificationOpen, setVerificationOpen] = useState(false);
    const { authToken, user, refreshDovePoints, wallet } = useAuth();
    const location = useLocation();
    const history = useHistory();
    let tab = ["."];
    const Dots = () => {
        for (var i = 0; i < 24; i++) {
            tab.push(".");
        }
    }
    Dots();
    const getFreePoints = () => {
        axios.post(`/wallet/api/payments/wallets/get-free-points/`, {}, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            refreshDovePoints();
            redirect(`${process.env.REACT_APP_INTERNAL_URL}create-campaign/`);
        })
    }
    const redirect = (path: string) => {
        history.push(path);
    }
    const steps = [
        {
            id: 1,
            title: "Provide basic information to define your campaign",
            description: "You will be able to choose the type of your ad campaign, name your ad campaign, and set start/end dates and other relevant metrics.",
        },
        {
            id: 2,
            title: "Provide content to be displayed",
            description: "Based on chosen type of ad campaign, you will be required to provide details about the ad, such as image, title, content, description, and video.",
        },
        {
            id: 3,
            title: "Choose location where your ads will be displayed",
            description: "You decide who sees your ads! You can select the location and further personalize your targeted consumers based on specialties, and other parameters. In case location information is not provided, then the ads are displayed globally.",
        },
        {
            id: 4,
            title: "Select DoveMed Products to display your ads",
            description: "We have a wide variety of products. We will show your advertisements based on your selection of the DoveMed products.",
        },
        {
            id: 5,
            title: "Decide the cost",
            description: "Decide about the cost by selecting display numbers. We have a unique cost-credit system. Your ads will be displayed based on your requirements and the number of credits you purchase.",
        }
    ];
    return (
        <StyledContainer>
                <SectionName>how to start</SectionName>
                <SectionTitle>Gain visibility in simple steps</SectionTitle>
                <Grid container spacing={2}>
                    <Grid item sm={12} md={6}>
                        <StepsContainer>
                            {steps.map(step => (
                                <Step key={step.id} step={step.id}>
                                    <StepNumber>{step.id}</StepNumber>
                                    <div>
                                        <StepTitle>{step.title}</StepTitle>
                                        <StepDescription>{step.description}</StepDescription>
                                    </div>
                                </Step>
                            ))}
                        </StepsContainer>
                        {authToken 
                            ? (user && user.verifiedAccount)
                                ? (wallet && wallet.hasWallet)
                                    ? <StyledButton to={`${process.env.REACT_APP_INTERNAL_URL}create-campaign`}>Start now</StyledButton>
                                    : <Button onClick={getFreePoints}>Start now</Button>
                                : <Button onClick={() => setVerificationOpen(true)}>Start now</Button>
                                
                            : 
                            <StyledButton to={{
                                pathname: location.pathname,
                                state: { openLogin: true }
                            }}>Start now</StyledButton>
                        }
                        <Verification open={verificationOpen} setOpen={setVerificationOpen} />            
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <ImageWrapper>
                            <Image src={image} alt="Homepage-Image" />
                            <DotContainer>
                                {tab.length > 0 && tab.map((e, index) => (
                                    <Dot key={index}></Dot>
                                ))}
                            </DotContainer>
                        </ImageWrapper>
                    </Grid>
                </Grid>
        </StyledContainer>
    )
}
